import { useMyTeams } from "shared/teams/useMyTeams";

import {
  getUserContext,
  getTeamContext,
  ActiveContext,
} from "shared/ContextSwitcher/ActiveContext";

import type { SessionWithUser } from "lib/users/types";
import type { DashboardSchedule } from "./useDashboardSchedule";
import type { DuneEntity } from "lib/orb/utils/externalCustomerId";

export function useScheduleContextOwner(
  session: SessionWithUser,
  existingSchedule: DashboardSchedule | undefined,
  owner: DuneEntity
): ActiveContext | undefined {
  const teams = useMyTeams(session);

  function getContext(owner: DuneEntity) {
    switch (owner.type) {
      case "user":
        return getUserContext(session);
      case "team": {
        const team = teams.find((team) => team.id === owner.id);

        if (!team) {
          return undefined;
        }

        return getTeamContext(team);
      }
    }
  }

  if (existingSchedule) {
    return getContext(existingSchedule.owner);
  } else {
    return getContext(owner);
  }
}
